import { Component, input } from '@angular/core';
import { AuditLogsComponent } from '../../../../parts/audit-logs/audit-logs.component';
import { AuditEntityType } from '../../../../core/enums/base.enums';
import { PropertyModel } from '../../../../core/models/data/property.model';

@Component({
  selector: 'ms-property-logs',
  imports: [AuditLogsComponent],
  templateUrl: './property-profile-logs.component.html'
})
export class PropertyProfileLogsComponent {
  public property = input<PropertyModel | undefined>(undefined);

  public AuditEntityType = AuditEntityType;
}
